module.exports = __webpack_public_path__ + "img/91eec0c.png";